import { useEffect } from 'react'
import { useLocation } from 'react-router'

/**
 * Reports page views to Google Analytics, when its `ga` global is loaded.
 * Must be used within the router.
 */
export function useReactRouterGaReporter() {
  const location = useLocation()
  useEffect(() => {
    if (window.ga) {
      window.ga('set', 'page', location.pathname)
      window.ga('send', 'pageview')
    }
  }, [location])
}
